import './_style.scss'
import Listener from '../../core/watcher/Listener'

Listener.onLoadDOM(() => {
   const classNameHideCard = 'compare__card--hide'
   const classNameActiveNavItem = 'compare__nav-item--active'
   let currentNavItem
   let currentTag
   let currentCards

   Listener.onClickAll('.compare__nav-item', event => {
      event.preventDefault()
      if (currentNavItem === event.currentTarget) {
         return
      }

      if (currentNavItem) {
         currentNavItem.classList.remove(classNameActiveNavItem)
      }

      currentNavItem = event.currentTarget
      currentNavItem.classList.add(classNameActiveNavItem)
      currentTag = currentNavItem.dataset.tag

      if (currentCards) {
         currentCards.forEach(card => card.classList.add(classNameHideCard))
      }
      currentCards = [...document.querySelectorAll('.compare__card')]
         .filter(card => card.dataset.tagValue === currentTag)
      currentCards.forEach(card => card.classList.remove(classNameHideCard))
   })
   document.querySelector('.compare__nav-item')?.click()
})